import BaseView from '@/store/modules/components/BaseView'

export default class DirectionsView extends BaseView {
    constructor() {
        super('directions')
    }
}
